import React, { useState } from 'react';
import { Zap, Wifi, Car, ShieldCheck } from 'lucide-react';
import Header from './components/Header';
import ServiceCard from './components/ServiceCard';
import LeadForm from './components/LeadForm';
import PartnerLogos from './components/PartnerLogos';

function HomePage() {
  const [selectedService, setSelectedService] = useState(null);

  const services = [
    { id: 'energy', title: 'Luce e Gas', icon: Zap },
    { id: 'internet', title: 'Internet', icon: Wifi },
    { id: 'rental', title: 'Noleggio Auto', icon: Car },
  ];

  return (
    <>
      <main className="flex-grow container mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight">
            Risparmia sulle tue <br className="hidden md:block" />
            utenze <span className="text-white relative inline-block">
              in pochi click
              <span className="absolute bottom-0 left-0 w-full h-3 bg-brand-accent -z-10 opacity-70 transform -rotate-1"></span>
            </span>
          </h1>
          <p className="text-lg text-brand-muted max-w-2xl mx-auto">
            Seleziona il servizio di cui hai bisogno, carica la tua bolletta e ricevi un preventivo personalizzato dai nostri esperti.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-4xl mx-auto mb-12">
          {services.map((service) => (
            <ServiceCard
              key={service.id}
              title={service.title}
              icon={service.icon}
              isSelected={selectedService === service.title}
              onClick={() => setSelectedService(service.title)}
            />
          ))}
        </div>

        {selectedService && (
          <div className="animate-fade-in-up mb-12">
            <LeadForm service={selectedService} />
          </div>
        )}
      </main>
        
      <PartnerLogos />
      
      <footer className="bg-brand-secondary text-brand-muted py-8 mt-auto border-t border-brand-primary">
        <div className="container mx-auto px-4 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Saving Solutions. Tutti i diritti riservati.</p>
          <div className="mt-2">
            <a href="/privacy" className="hover:text-brand-accent transition-colors underline">Privacy Policy</a>
          </div>
        </div>
      </footer>
    </>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-brand-gradient flex flex-col font-sans text-brand-text">
      <Header />
      <HomePage />
    </div>
  );
}

export default App;
